import { Navigate, Outlet } from 'react-router-dom'
import { useIsAuthenticated } from '../store/auth'

/**
 * Layout route that guards all authenticated pages.
 * Unauthenticated visitors are sent to /login; everyone else sees the nested routes.
 */
export function ProtectedRoute() {
  const isAuthenticated = useIsAuthenticated()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
